import { SketchPicker } from 'react-color';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import './colorPicker.scss';
import rgbHex from 'rgb-hex';
import { colorPickerStyles, presetColors } from './colorPickerConfig.js';

const ColorPicker = ({ isPickerVisible, setIsPickerVisible, handlePickColor, pickedColor }) => {
  const [color, setColor] = useState(pickedColor || '');

  useEffect(() => {
    setColor(pickedColor || '');
  }, [pickedColor]);

  const handleColorChange = (newColor) => {
    const hexCode = rgbHex(
      newColor.rgb.r,
      newColor.rgb.g,
      newColor.rgb.b,
      newColor.rgb.a,
    );
    setColor('#' + hexCode);
  };

  return (
    <div>
      {isPickerVisible && (
        <div className='color-picker-container'>
          <SketchPicker
            color={color}
            onChangeComplete={handleColorChange}
            styles={colorPickerStyles}
            presetColors={presetColors}
          />

          <div className='color-picker-button-container'>
            <button
              id="color-picker-cancel-btn"
              onClick={() => setIsPickerVisible(false)}
              className='color-picker-cancel-btn'
            >
              Cancel
            </button>
            <button
              id="color-select-color-btn"
              disabled={!color}
              onClick={() => handlePickColor(color.slice(0, 7))}
              className='color-select-color-btn'
            >
              Select Color
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorPicker;

ColorPicker.propTypes = {
  isPickerVisible: PropTypes.bool.isRequired,
  setIsPickerVisible: PropTypes.func.isRequired,
  handlePickColor: PropTypes.func.isRequired,
  pickedColor: PropTypes.string, // Add pickedColor prop
};
